"use client";

import { colors, text, font, typo, radius } from "@/styles/design-tokens";
import { useIsDesktop } from "@/hooks/useIsDesktop";

const EXAMPLE_TASKS = [
  "Analyze my competitors",
  "Write a blog post",
  "Review my code",
  "Create a marketing plan",
];

interface WelcomeStateProps {
  onChipClick: (text: string) => void;
}

export default function WelcomeState({ onChipClick }: WelcomeStateProps) {
  const isDesktop = useIsDesktop();
  const iconSize = isDesktop ? 40 : 60;
  return (
    <div className="flex-1 flex items-center justify-center h-full">
      <div className="flex flex-col items-center" style={{ maxWidth: 720, width: 720 }}>
        {/* Robot icon — 40px on desktop per Figma 83:7461, 60px on web. */}
        <div className="app-anim-fade-up" style={{ padding: 12 }}>
          <img
            src="/app-icons/robot.svg"
            alt=""
            className="app-anim-float"
            style={{ width: iconSize, height: iconSize }}
          />
        </div>

        {/* Heading */}
        <div className="app-anim-fade-up-d100" style={{ paddingBottom: 12 }}>
          <h1
            className="text-center whitespace-nowrap"
            style={{
              fontFamily: font.heading,
              fontWeight: typo.headingXl.fontWeight,
              fontSize: typo.headingXl.fontSize,
              lineHeight: typo.headingXl.lineHeight,
              letterSpacing: typo.headingXl.letterSpacing,
              color: text.heading,
            }}
          >
            What do you need done?
          </h1>
        </div>

        {/* Subtitle */}
        <div className="app-anim-fade-up-d200" style={{ maxWidth: 500, paddingBottom: 48 }}>
          <p
            className="text-center desktop-balance-text"
            style={{
              fontFamily: font.heading,
              fontWeight: typo.subtitle.fontWeight,
              fontSize: typo.subtitle.fontSize,
              lineHeight: typo.subtitle.lineHeight,
              color: text.muted,
              opacity: 0.8,
            }}
          >
            Your specialized autonomous agents are ready to assist
            with deep analysis, creative writing, or technical
            architecture.
          </p>
        </div>

        {/* Suggestion chips */}
        <div className="app-anim-fade-up-d300" style={{ paddingBottom: 48 }}>
          <div className="flex flex-wrap justify-center" style={{ gap: 12, width: 720 }}>
            {EXAMPLE_TASKS.map((task) => (
              <button
                key={task}
                onClick={() => onChipClick(task)}
                className="app-chip whitespace-nowrap desktop-glass-chip"
                style={{
                  padding: "11px 25px",
                  borderRadius: radius.full,
                  background: colors.chipBg,
                  border: `1px solid ${colors.chipBorder}`,
                  fontFamily: font.heading,
                  fontWeight: typo.chip.fontWeight,
                  fontSize: typo.chip.fontSize,
                  lineHeight: typo.chip.lineHeight,
                  color: text.body,
                }}
              >
                {task}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
